<template>
  <v-container v-if="loaded">
    <h1 class="display-3">Рейтинг участников</h1>
    <RatingTable
      :top5="top5"
      :myRank="myRank"
      :myScore="myScore"
      :count="count"
    />
  </v-container>
  <v-container v-else>
    <v-skeleton-loader
      class="mt-4"
      loading
      tile
      type="heading, table-tbody"
    ></v-skeleton-loader>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import RatingTable from '../components/RatingTable'
export default {
  name: 'Rating',
  components: {
    RatingTable
  },
  data() {
    return {
      top5: [],
      myRank: 0,
      myScore: {},
      count: 0,
      loaded: false
    }
  },
  mounted() {
    this.request('api/rating').then(body => {
      this.top5 = body.data.top5
      this.myRank = body.data.myRank
      this.myScore = body.data.myScore
      this.count = body.data.count
      this.loaded = true
    })
  },
  methods: {
    ...mapActions(['request'])
  }
}
</script>
<style scoped>
tr.special td {
  font-weight: bold;
}
</style>
